import { render, staticRenderFns } from "./privacyPolicyForMens.vue?vue&type=template&id=0a73840f&scoped=true"
import script from "./privacyPolicyForMens.vue?vue&type=script&lang=ts"
export * from "./privacyPolicyForMens.vue?vue&type=script&lang=ts"
import style0 from "./privacyPolicyForMens.vue?vue&type=style&index=0&id=0a73840f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a73840f",
  null
  
)

export default component.exports